<template>
  <div class="mx-2 mt-1">
    <!-- Modal de Cumpleaños Especial -->
    <div v-if="showBirthdayModal" class="birthday-overlay">
      <div class="birthday-card shadow-lg p-4 rounded-4 text-center position-relative">
        <button type="button" class="btn-close position-absolute top-0 end-0 m-3" @click="showBirthdayModal = false"></button>
        <div class="py-3">
          <h1 class="display-4 mb-3 animate-bounce">🎂</h1>
          <h2 class="fw-bold text-purple mb-2">¡Feliz Cumpleaños!</h2>
          <p class="fs-5 text-secondary">Deseamos que pases un día extraordinario. <br> ¡Gracias por ser parte del equipo! 🥳✨</p>
        </div>
        <div class="mt-3">
          <button class="btn btn-purple text-white px-4" @click="showBirthdayModal = false">¡Gracias!</button>
        </div>
      </div>
    </div>

    <!-- Navbar -->
    <nav class="bg-solimano py-2 px-2" >
      <!-- Container wrapper -->
      <div class="d-flex  align-items-center justify-content-center">
        <!-- Toggle button -->

        <!-- Collapsible wrapper -->

        <div :class="{ 'me-auto ms-2 d-flex ': !isMobile, 'mx-auto d-flex': isMobile }">
          <!-- Navbar brand -->
          <figure class="my-auto">
            <img :class="{ 'mt-1': isMobile }" src="@/assets/Navbarhorizontal/Topas.png" :height="!isMobile ? 30 : 60"
              :width="!isMobile ? 110 : 210" alt="MDB Logo" />
          </figure>


        </div>



        <div v-if="!isMobile" class="ms-auto d-flex align-items-center">
          <!-- Icon -->

          <!-- Notifications -->
          <div v-if="permisoVisualizador != 11" class="dropdown ms-1 me-3 d-flex align-items-center">
            <a class="text-reset me-2 dropdown-toggle hidden-arrow mx-0" href="#" id="navbarDropdownMenuLink"
              role="button" data-mdb-toggle="dropdown" aria-expanded="false">
              <span class="badge rounded-pill badge-notification bg-danger">{{
                numeroRq
              }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-bell text-white mx-0" viewBox="0 0 16 16">
                <path
                  d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
              </svg>
            </a>


            <div v-if="permisoVisualizador != 11" class="ms-2   align-self-center">
              <h6 class="text-white py-0 my-1 perfiles-user">
                BIENVENIDO(A): {{ NombresUsers }}
              </h6>
              <h6 v-if="permisoVisualizador != 11" class="text-white  py-0 my-1 perfiles-user">
                {{ Cargos }}
              </h6>
              <!-- <h6 v-if="permisoVisualizador != 11" class="text-white  py-0 my-1 perfiles-user">
                  {{ Correo }}
              </h6> -->
              <!-- <h6 class="text-white py-0 my-0 perfiles-user">
             
            </h6> -->
            </div>

          </div>
          <!-- Avatar -->
          <div class="dropdown">
            <button v-if="permisoVisualizador != 11" @click="cerrarSesion" class="btn btn-white border-2 text-white"
              aria-expanded="false">
              →
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                class="bi bi-door-open text-white" viewBox="0 0 16 16">
                <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z" />
                <path
                  d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z" />
              </svg>
            </button>


            <button v-else @click="cerrarSesionPostulante" class="btn btn-white border-2 text-white"
              aria-expanded="false">
              →
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                class="bi bi-door-open text-white" viewBox="0 0 16 16">
                <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z" />
                <path
                  d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z" />
              </svg>
            </button>
          </div>
        </div>
        <!-- Right elements -->
      </div>
      <!-- Container wrapper -->

      <div v-if="isMobile" class="text-center mt-4">
        <h6 class="text-white py-0 my-1 perfiles-user" style="font-size: 1.15rem">
          Bienvenido(a): {{ NombresUsers }}
        </h6>
      </div>

      <div v-if="isMobile" class="text-center">

        <button @click="cerrarSesionPostulante" class="btn btn-white border-2 text-white" aria-expanded="false">
          →
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
            class="bi bi-door-open text-white" viewBox="0 0 16 16">
            <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z" />
            <path
              d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z" />
          </svg>
        </button>
      </div>

    </nav>
    <!-- Navbar -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SolimanologNavbarHorizontal",

  data() {
    return {
      isMobile: false,

      numeroRq: "",
      permisoVisualizador: "",
      isSpecialUser: false,
      showBirthdayModal: false
    };
  },

  mounted() {
     const fechaNacimiento = localStorage.getItem("usuFecNacimiento");
     if (fechaNacimiento) {
       const hoy = new Date();
      // Obtenemos el mes y día actual en formato "MM-DD"
       const hoyMesDia = `${String(hoy.getMonth() + 1).padStart(2, "0")}-${String(hoy.getDate()).padStart(2, "0")}`;

      // Verificamos si la fecha de nacimiento guardada contiene el mes y día de hoy
      if (fechaNacimiento.includes(hoyMesDia)) {
        this.showBirthdayModal = true;
        //Auto cerrar después de 5 segundos
        setTimeout(() => {
          this.showBirthdayModal = false;
        }, 5000);
      }
    }

    this.loadData(); // Cargar los datos cuando se monta el componente
    this.intervalId = setInterval(this.loadData, 90000); //
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    console.log(this.permisoVisualizador)

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);

  },

  beforeDestroy() {
    clearInterval(this.intervalId); // Detener la actualización cuando el componente se destruye
  },

  computed: {
    ...mapGetters("users", ["Correo", "NombresUsers", "Cargos"]),
  },

  methods: {

    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    cerrarSesion() {
      window.location.reload(true);
      localStorage.clear();
      this.$router.push("/");
      this.$store.dispatch("acciones/CambioNavbar", false);
    },

    cerrarSesionPostulante() {
      // window.location.reload(true);
      localStorage.clear();
      this.$router.push("/loginPostulante");
      this.$store.dispatch("acciones/CambioNavbar", false);


    },
    loadData() {
      this.axios.get(`Autentication/CantidadRqs`).then((r) => {
        console.log(r.data);
        this.numeroRq = r.data.cantidadrqs;
      });
    },
  },
};
</script>

<style scoped>
.bg-solimano {
  background: #002c5d;
}

.bg-special {
  background: #9E10DE !important;
}

.text-purple {
  color: #9E10DE;
}

.btn-purple {
  background-color: #9E10DE;
  border-color: #9E10DE;
}

.btn-purple:hover {
  background-color: #840dbb;
  border-color: #840dbb;
}

.transition-color {
  transition: background-color 0.5s ease;
}

.birthday-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.birthday-card {
  background: rgb(253, 253, 253);
  max-width: 450px;
  width: 90%;
  animation: popIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes popIn {
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.animate-bounce {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
  40% {transform: translateY(-20px);}
  60% {transform: translateY(-10px);}
}

.perfiles-user {
  font-size: 0.58rem;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.palito {
  width: 1px;
  height: auto;
  background-color: rgb(255, 255, 255);
}
</style>